// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".copy-to-clipboard[data-v-17c498dc]{border:none;padding:0;background:none}.copy-to-clipboard[data-v-17c498dc]:hover [fill=\"#16171F\"]{transition:fill .3s ease-in-out,color .3s ease-in-out;fill:var(--hover-color);color:var(--hover-color)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
